import { Component, Input } from '@angular/core';
import { environment } from 'src/environments/environment';
import { environmentCommon } from 'src/environments/environment-common';
import { URLS } from '../../../data/navigation/navigation.data';
import { Review } from '../../../model/review/review.model';

@Component( {
  selector: 'app-review-card',
  templateUrl: './review-card.component.html',
  styleUrls: [ './review-card.component.scss' ],
} )
export class ReviewCardComponent {
  URLS = URLS;

  environment = environment;
  environmentCommon = environmentCommon;

  @Input() review: Review = {
    reviewer: '',
    stars: 5,
    review: '',
    date: ''
  };

  /** Flips to true when the avatar image 404s, so we fall back to the initial. */
  avatarFailed = false;

  constructor() {
    // Intentionally blank
  }

  generateRange( n: number ): number[] {
    return Array.from( { length: n }, ( _, index ) => index );
  }

  /** First letter of the reviewer's name for the fallback avatar badge. */
  get initial(): string {
    const name = ( this.review?.reviewer || '' ).trim();
    return name ? name.charAt( 0 ).toUpperCase() : '?';
  }

  get showAvatar(): boolean {
    return !!this.review?.avatar && !this.avatarFailed;
  }
}
